import React from 'react';
import { useQuery } from 'react-query';

import { TRIP_API } from '../../../api/trips';
import TripAnomaliesMap from '../../../views-admin/trip-anomalies/TripAnomaliesMap';
import ErrorBoundary from '../../ErrorBoundary';
import Spinner from '../../Spinner';
import Text from '../../Text';

const ExpandedTripWithAnomalyRow = ({
  tripId,
  t,
  setSelectedMapConfig,
  openTripDetailsModalVisible,
}) => {
  const tripDetailsQuery = useQuery(['fetchTripDetails', tripId], {
    staleTime: Infinity,
    queryFn: () => TRIP_API.fetchTripDetails(tripId),
    enabled: !!tripId,
  });

  return (
    <Spinner spinning={tripDetailsQuery.isFetching}>
      <ErrorBoundary>
        <div
          style={{
            display: 'flex',
            gap: '20px',
            width: 'fit-content',
            marginBottom: '32px',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ flex: 1 }}>
            <Text variant="strong">{t('currentTripRoute')}</Text>
            <TripAnomaliesMap
              t={t}
              journeyGeoJson={tripDetailsQuery.data?.journeyGeoJson}
              onViewFullScreenClick={(trp, activeRoutes, mapCenter) => {
                setSelectedMapConfig({
                  routes: activeRoutes,
                  center: mapCenter,
                });
                openTripDetailsModalVisible();
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text variant="strong">{t('suggestedChangeToTripRoute')}</Text>
            <TripAnomaliesMap
              t={t}
              journeyGeoJson={tripDetailsQuery.data?.newJourneyGeoJson}
              onViewFullScreenClick={(trp, activeRoutes, mapCenter) => {
                setSelectedMapConfig({
                  routes: activeRoutes,
                  center: mapCenter,
                });
                openTripDetailsModalVisible();
              }}
            />
          </div>
        </div>
      </ErrorBoundary>
    </Spinner>
  );
};

export default ExpandedTripWithAnomalyRow;
